import React, { useEffect, useState, useContext } from 'react';
import Skeleton from '../../../../../../../components/OtherElements/CustomSkeleton';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import axios from '../../../../../../../api/axios';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import CustomSelect from '@material-ui/core/Select';
import DatePicker from '../../../../../../../components/Dialog/DatePicker';
import moment from 'moment-jalaali';
import { useParams } from 'react-router-dom';
import { toEN } from '../../../../../../../fns';
import { store } from '../Driver';
import { store as mainStore } from '../../../../../../../store';
import FleetsTF from '../../../../../../../components/TextFields/FleetsTextFields';

const useStyles = makeStyles((theme) => ({
  pelak: {
    height: '56px',
    backgroundImage: 'url(../../../files/img/pelak.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
  },
}));

const Fleets = () => {
  const classes = useStyles();
  const [submiting, setSubmiting] = useState(false);
  const { showMessage, showError } = useContext(mainStore);
  const { state, dispatch } = useContext(store);
  const { driver, fetchingUserData } = state;
  var { id } = useParams();
  // DatePicker's open or close dialog state and the field that fills it
  const [datePicker, setDatePicker] = useState({
    open: false,
    fieldName: null,
  });
  //changes values must to send via api
  const handleChange = (e) => {
    let { name, value } = e.target;
    dispatch({ type: 'CHANGE_DRIVER_INFO', payload: { name, value } });
  };
  // numberPlate's alphabet code array
  const alefba = [
    'الف',
    'ب',
    'پ',
    'ت',
    'ث',
    'ج',
    'چ',
    'ح',
    'خ',
    'د',
    'ذ',
    'ر',
    'ز',
    'ژ',
    'س',
    'ش',
    'ص',
    'ض',
    'ط',
    'ظ',
    'ع',
    'غ',
    'ف',
    'ق',
    'ک',
    'گ',
    'ل',
    'م',
    'ن',
    'و',
    'ه',
    'ی',
  ];
  // all avaiable insurance companies array:
  const insuranceNameList = [
    'بیمه آرمان',
    'بیمه آسماری',
    'بیمه آسیا',
    'بیمه اتکایی ایرانیان',
    'بیمه البرز',
    'بیمه امید',
    'بیمه ایران',
    'بیمه ایران معین',
    'بیمه پارسیان',
    'بیمه پاسارگاد',
    'بیمه تجارت نو',
    'بیمه خاورمیانه',
    'بیمه تعاون',
    'بیمه توسعه',
    'بیمه حافظ',
    'بیمه دانا',
    'بیمه دی',
    'بیمه رازی',
    'بیمه سامان',
    'بیمه سرمد',
    'بیمه سینا',
    'بیمه کارآفرین',
    'بیمه کوثر',
    'بیمه ما',
    'بیمه معلم',
    'بیمه ملت',
    'بیمه میهن',
    'بیمه نوین',
    'شرکت بیمه متقابل اطمینان متحد قشم',
    'موسسه بیمه متقابل کیش',
  ];

  const handleOpenDatePicker = (e) => {
    const { name } = e.target;
    setDatePicker({ open: true, fieldName: name });
  };
  // on closing datepicker dialog box happens:
  const handleCloseDatePicker = ({ date, fieldName }) => {
    dispatch({
      type: 'CHANGE_DRIVER_INFO',
      payload: { name: fieldName, value: date },
    });
    setDatePicker({ open: false, fieldName: null });
  };
  const handleSubmit = async () => {
    setSubmiting(true);
    let {
      smartcard,
      insuranceCompany,
      carInsurance,
      carInsuranceExpireDate,
      thirdPartyInsuranceExpireDate,
      thirdPartyInsurance,
      fleetOptions,
      numberPlate,
    } = driver;
    if (numberPlate && !numberPlate.cityCode) {
      numberPlate.cityCode = 96;
    }
    if (numberPlate && !numberPlate.alphabetCode) {
      numberPlate.alphabetCode = 'د';
    }

    try {
      const { data: response } = await axios.put(`/api/v1/admin/driver/${id}`, {
        numberPlate,
        smartcard,
        insuranceCompany,
        carInsurance,
        carInsuranceExpireDate,
        thirdPartyInsuranceExpireDate,
        thirdPartyInsurance,
        fleetOptions,
      });
      showMessage(response.messages);
      const d = await fetchingUserData(id);
      dispatch({ type: 'LOAD', payload: { name: 'driver', value: d } });
    } catch (error) {
      showError(error);
    }
    setSubmiting(false);
  };
  const handleChangeFleets = (fleetOptions) => {
    dispatch({
      type: 'CHANGE_DRIVER_INFO',
      payload: { name: 'fleetOptions', value: fleetOptions },
    });
  };
  const handleChangeFleetPlate = (e) => {
    const { name, value } = e.target;
    dispatch({ type: 'CHANGE_FLEET_PLATE', payload: { name, value } });
  };

  return (
    <>
      <div className={classes.root}>
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <Typography component="h2" variant="h2">
              اطلاعات راننده و ناوگان:
            </Typography>
          </Grid>
          <Grid item>
            {driver ? (
              <FleetsTF
                onChange={handleChangeFleets}
                single
                selection={driver.fleetOptions ? driver.fleetOptions : []}
                variant="filled"
              />
            ) : (
              <Skeleton />
            )}
          </Grid>
          <Grid item>
            <div className={classes.pelak}>
              <Grid container>
                <Grid item xs={3}>
                  <TextField
                    variant="filled"
                    color="secondary"
                    name="cityCode"
                    value={
                      driver &&
                      driver.numberPlate &&
                      driver.numberPlate.cityCode
                        ? driver.numberPlate.cityCode
                        : '96'
                    }
                    onChange={handleChangeFleetPlate}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    variant="filled"
                    color="secondary"
                    name="firstCode"
                    value={
                      driver &&
                      driver.numberPlate &&
                      driver.numberPlate.firstCode
                        ? driver.numberPlate.firstCode
                        : '000'
                    }
                    onChange={handleChangeFleetPlate}
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormControl variant="filled" fullWidth>
                    <InputLabel>حروف</InputLabel>
                    <CustomSelect
                      name="alphabetCode"
                      value={
                        driver &&
                        driver.numberPlate &&
                        driver.numberPlate.alphabetCode
                          ? driver.numberPlate.alphabetCode
                          : 'د'
                      }
                      onChange={handleChangeFleetPlate}
                    >
                      {alefba.map((name) => (
                        <MenuItem name="alphabetCode" key={name} value={name}>
                          {name}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                  </FormControl>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    variant="filled"
                    color="secondary"
                    name="secondCode"
                    value={
                      driver &&
                      driver.numberPlate &&
                      driver.numberPlate.secondCode
                        ? driver.numberPlate.secondCode
                        : '00'
                    }
                    onChange={handleChangeFleetPlate}
                  />
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="هوشمند ناوگان"
              variant="filled"
              size="medium"
              name="smartcard"
              value={driver && driver.smartcard ? driver.smartcard : ''}
              onChange={handleChange}
              type="number"
            />
          </Grid>
          <Grid item>
            <FormControl variant="filled" fullWidth>
              <InputLabel>شرکت بیمه گر</InputLabel>
              <CustomSelect
                value={
                  driver && driver.insuranceCompany
                    ? driver.insuranceCompany
                    : ''
                }
                onChange={handleChange}
                name="insuranceCompany"
              >
                {insuranceNameList.map((name) => (
                  <MenuItem name="insuranceCompany" key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </CustomSelect>
            </FormControl>
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="شماره بیمه نامه بدنه"
              variant="filled"
              size="medium"
              name="carInsurance"
              value={driver && driver.carInsurance ? driver.carInsurance : ''}
              onChange={handleChange}
              type="number"
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="تاریخ پایان اعتبار بیمه بدنه"
              name="carInsuranceExpireDate"
              value={
                driver && driver.carInsuranceExpireDate
                  ? moment(driver.carInsuranceExpireDate).format(
                      'jYYYY/jMM/jDD'
                    )
                  : ''
              }
              onClick={handleOpenDatePicker}
              variant="filled"
              size="medium"
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="شماره بیمه نامه شخص ثالث"
              variant="filled"
              size="medium"
              name="thirdPartyInsurance"
              value={
                driver && driver.thirdPartyInsurance
                  ? driver.thirdPartyInsurance
                  : ''
              }
              onChange={handleChange}
              type="number"
            />
          </Grid>
          <Grid item>
            <TextField
              fullWidth
              label="تاریخ پایان اعتبار بیمه ثالث"
              variant="filled"
              size="medium"
              name="thirdPartyInsuranceExpireDate"
              value={
                driver && driver.thirdPartyInsuranceExpireDate
                  ? moment(driver.thirdPartyInsuranceExpireDate).format(
                      'jYYYY/jMM/jDD'
                    )
                  : ''
              }
              onClick={handleOpenDatePicker}
            />
          </Grid>

          <Grid item>
            <Button
              disabled={submiting}
              variant="contained"
              color="secondary"
              fullWidth
              size="large"
              onClick={handleSubmit}
            >
              بروزرسانی اطلاعات
            </Button>
          </Grid>
        </Grid>
      </div>
      <DatePicker data={datePicker} onClose={handleCloseDatePicker} />
    </>
  );
};

export default React.memo(Fleets);
